import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 9026C3EC-9903-40FE-B3DF-EDB7FE10191A
 * name layers-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/layers-outline.svg
 * tags
 * - Geographic Information System 
 */
export const LayersOutlineIcon = createSvgIcon(<><path d="M12,18.54L19.37,12.8L21,14.07L12,21.07L3,14.07L4.62,12.81L12,18.54M12,16L3,9L12,2L21,9L12,16M12,4.53L6.26,9L12,13.47L17.74,9L12,4.53Z" /></>, 'LayersOutlineIcon');
export default LayersOutlineIcon